module.exports = __webpack_public_path__ + "components/forecast-table-elevation/static/bot-351d8159ffe11772ad1361ac8fc8ac08.svg";